import AddIcon from "@mui/icons-material/Add";

import CloseIcon from "@mui/icons-material/Close";

import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import CategoryIcon from "@mui/icons-material/Category";

import {
    Box,
    Drawer,
    Grid,
    IconButton,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useMemo,
    useState,
} from "react";

import { useTranslation } from "react-i18next";

import DialogActionButtons from "../../../components/Dialog/Footer";

import TextInput from "../../../components/TextInputs";

import { getAllBasePackages } from "../../../services/basePackagesFn";
import PackageCard from "../../../components/Cards/PackageCard";

import ProductCardSkeleton from "../../../components/Skeleton/ProductCardSkeleton";

import { getAllEcomCategory } from "../../../services/ecomCategoryApiFn";

import CustomSelect from "../../../components/customSelect";

import { useSelector } from "react-redux";

import { getAllEcomSubCategory } from "../../../services/ecomSubCategoryApiFn";

import { getAllEcomSubSubCategory } from "../../../services/ecomSubSubCategoryApiFn";

import useDebounce from "../../../hooks/useDebounce";

import GlobalButton from "../../../components/CustomButton";
import { handleOpenSnackBar } from "../../../utils";

const PACKAGE_LIMIT = 10;

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    zIndex: theme.zIndex.modal,

    "& .MuiDrawer-paper": {
        width: "100%",

        maxWidth: "100%",

        height: "100%",

        display: "flex",

        flexDirection: "column",
    },
}));

let paramsData = {};

const AttachedBasePackageDialog = forwardRef(({ selectedBasePackages = [], setSelectedBasePackages }, ref) => {
    const [open, setOpen] = useState(false);

    const { t } = useTranslation(["common"]);

    const [draftSelectedBasePackages, setDraftSelectedBasePackages] = useState([]);

    const selectedBasePackageIds = useMemo(
        () => new Set(draftSelectedBasePackages.map((pkg) => pkg._id)),
        [draftSelectedBasePackages],
    );

    const currentLanguage = useSelector(
        (state) => state.languageReducer.currentLanguage,
    );

    const [searchBasePackage, setSearchBasePackage] = useState("");

    const [categoryId, setCategoryId] = useState("All");

    const [subCategoryId, setSubCategoryId] = useState("All");

    const [subSubCategoryId, setSubSubCategoryId] = useState("All");

    const [allCategories, setAllCategories] = useState([]);

    const [allSubCategories, setAllSubCategories] = useState([]);

    const [allSubSubCategories, setAllSubSubCategories] = useState([]);

    const [allBasePackages, setAllBasePackages] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const [pagination, setPagination] = useState({
        page: 1,

        limit: PACKAGE_LIMIT,

        total: 0,

        totalPages: 0,

        hasMore: false,
    });

    const debouncedSearchBasePackage = useDebounce(searchBasePackage, 500);

    const hasActiveFilters =
        searchBasePackage !== "" ||
        categoryId !== "All" ||
        subCategoryId !== "All" ||
        subSubCategoryId !== "All";

    useImperativeHandle(ref, () => ({
        openDialog(params) {
            paramsData = params;

            setOpen(true);
        },

        closeDialog() {
            setOpen(false);
        },
    }));

    const resetFiltersState = () => {
        setSearchBasePackage("");

        setCategoryId("All");

        setSubCategoryId("All");

        setSubSubCategoryId("All");

        setAllSubCategories([]);

        setAllSubSubCategories([]);
    };

    const handleClose = () => {
        setOpen(false);
        setDraftSelectedBasePackages([]);
        setAllBasePackages([]);

        resetFiltersState();

        setPagination({
            page: 1,

            limit: PACKAGE_LIMIT,

            total: 0,

            totalPages: 0,

            hasMore: false,
        });

        setIsLoading(false);

        setIsLoadingMore(false);
    };

    const handleSave = () => {
        setSelectedBasePackages?.(draftSelectedBasePackages);
        handleClose();
    };

    const handleToggleBasePackage = (basePackage) => {
        setDraftSelectedBasePackages((prev) => {
            const isAlreadySelected = prev.some((item) => item._id === basePackage._id);
            if (isAlreadySelected) {
                return prev.filter((item) => item._id !== basePackage._id);
            }
            return [...prev, basePackage];
        });
    };

    const handleResetFilters = () => {
        resetFiltersState();

        fetchchedAllBasePackages(1, true, {
            search: "",

            categoryId: "All",

            subCategoryId: "All",

            subSubCategoryId: "All",
        });
    };

    const fetchchedAllCategories = async () => {
        try {
            const response = await getAllEcomCategory();

            if (response?.data?.status === "success") {
                setAllCategories(response?.data?.data);
            } else {
                handleOpenSnackBar("error", response?.data?.message);
            }
        } catch (error) {
            handleOpenSnackBar("error", error?.message);
        }
    };

    const fetchchedAllSubCategories = async (value) => {
        try {
            const response = await getAllEcomSubCategory("", value);

            if (response?.data?.status === "success") {
                setAllSubCategories(response?.data?.data);
            } else {
                handleOpenSnackBar("error", response?.data?.message);
            }
        } catch (error) {
            handleOpenSnackBar("error", error?.message);
        }
    };

    const fetchchedAllSubSubCategories = async (value1, value2) => {
        try {
            const response = await getAllEcomSubSubCategory("", value1, value2);

            if (response?.data?.status === "success") {
                setAllSubSubCategories(response?.data?.data);
            } else {
                handleOpenSnackBar("error", response?.data?.message);
            }
        } catch (error) {
            handleOpenSnackBar("error", error?.message);
        }
    };

    const fetchchedAllBasePackages = async (
        page = 1,
        replace = false,
        filterOverrides = null,
    ) => {
        const search = filterOverrides?.search ?? debouncedSearchBasePackage ?? "";

        const cat = filterOverrides?.categoryId ?? categoryId;

        const subCat = filterOverrides?.subCategoryId ?? subCategoryId;

        const subSubCat = filterOverrides?.subSubCategoryId ?? subSubCategoryId;

        const query = {
            search: search || "",

            categoryId: cat === "All" ? "" : cat || "",

            subCategoryId: subCat === "All" ? "" : subCat || "",

            subSubCategoryId: subSubCat === "All" ? "" : subSubCat || "",

            page: page || 1,

            limit: PACKAGE_LIMIT,
        };

        try {
            if (replace) setIsLoading(true);
            else setIsLoadingMore(true);

            const response = await getAllBasePackages(query);

            if (response?.data?.status === "success") {
                const basePackages = response?.data?.data?.data || [];

                const paginationData = response?.data?.data?.pagination || {};

                setAllBasePackages((prev) => (replace ? basePackages : [...prev, ...basePackages]));

                setPagination({
                    page,

                    limit: paginationData.limit || PACKAGE_LIMIT,

                    total: paginationData.totalProducts ?? paginationData.total ?? 0,

                    totalPages: paginationData.totalPages ?? 0,

                    hasMore: paginationData.hasMore ?? false,
                });
            } else {
                handleOpenSnackBar("error", response?.data?.message);
            }
        } catch (error) {
            handleOpenSnackBar("error", error?.message);
        } finally {
            setIsLoading(false);

            setIsLoadingMore(false);
        }
    };

    const handleLoadMore = (e) => {
        e?.preventDefault?.();

        e?.stopPropagation?.();

        if (isLoading || isLoadingMore || !pagination.hasMore) return;

        fetchchedAllBasePackages(pagination.page + 1, false);
    };

    useEffect(() => {
        if (open) {
            setDraftSelectedBasePackages([...selectedBasePackages]);
        }
    }, [open]);

    useEffect(() => {
        if (!open) return;

        fetchchedAllBasePackages(1, true);
    }, [
        open,
        debouncedSearchBasePackage,
        categoryId,
        subCategoryId,
        subSubCategoryId,
    ]);

    useEffect(() => {
        fetchchedAllCategories();
    }, []);

    return (
        <StyledDrawer anchor="right" open={open} onClose={handleClose}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    px: 3,

                    py: 2,

                    borderBottom: "1px solid",

                    borderColor: "divider",

                    flexShrink: 0,
                }}
            >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <IconButton
                        aria-label="icon"
                        sx={{
                            backgroundColor: "#F5F5F5",

                            color: (theme) => theme.palette.text.primary,
                        }}
                    >
                        <AddIcon />
                    </IconButton>

                    <Stack>
                        <Typography
                            variant="h6"
                            fontWeight={600}
                            lineHeight="normal"
                            textTransform="capitalize"
                        >
                            {t("attachedBasePackages")}
                        </Typography>

                        <Typography
                            variant="body2"
                            color="text.secondary"
                            lineHeight="normal"
                        >
                            {t("selectBasePackagesToAttachToBlog")} ({draftSelectedBasePackages.length}{" "}
                            {t("selected", { ns: "common" })})
                        </Typography>
                    </Stack>
                </Stack>

                <IconButton aria-label="close" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>

            <Box sx={{ flex: 1, overflow: "auto", px: 3, py: 2 }}>
                <Grid
                    container
                    spacing={2}
                    rowSpacing={2}
                    columnSpacing={2}
                    alignItems="center"
                >
                    <Grid item xs={12} sm={6} md={3}>
                        <TextInput
                            id="search-base-package"
                            name="searchBasePackage"
                            value={searchBasePackage}
                            onChange={(e) => setSearchBasePackage(e.target.value)}
                            placeholder={t("searchBasePackages")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomSelect
                            placeholder={t("category", { ns: "common" })}
                            formStyleProps={{
                                "& .MuiInputBase-input": {
                                    textTransform: "capitalize",
                                },
                            }}
                            icon={
                                <CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />
                            }
                            value={categoryId}
                            onChange={(e) => {
                                const value = e.target.value;

                                setCategoryId(value);

                                setSubCategoryId("All");

                                setSubSubCategoryId("All");

                                setAllSubCategories([]);

                                setAllSubSubCategories([]);

                                if (value !== "All") {
                                    fetchchedAllSubCategories(value);
                                }
                            }}
                        >
                            <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>

                            {allCategories.map((val, ind) => (
                                <MenuItem
                                    key={ind}
                                    value={val._id}
                                    sx={{ textTransform: "capitalize" }}
                                >
                                    {val.name[currentLanguage]}
                                </MenuItem>
                            ))}
                        </CustomSelect>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomSelect
                            placeholder={t("subCategory", { ns: "common" })}
                            formStyleProps={{
                                "& .MuiInputBase-input": {
                                    textTransform: "capitalize",
                                },
                            }}
                            icon={
                                <CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />
                            }
                            value={subCategoryId}
                            onChange={(e) => {
                                const value = e.target.value;

                                setSubCategoryId(value);

                                setSubSubCategoryId("All");

                                setAllSubSubCategories([]);

                                if (value !== "All") {
                                    fetchchedAllSubSubCategories(categoryId, value);
                                }
                            }}
                        >
                            <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>

                            {allSubCategories.map((val, ind) => (
                                <MenuItem
                                    key={ind}
                                    value={val._id}
                                    sx={{ textTransform: "capitalize" }}
                                >
                                    {val.name[currentLanguage]}
                                </MenuItem>
                            ))}
                        </CustomSelect>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomSelect
                            placeholder={t("subSubCategory", { ns: "common" })}
                            formStyleProps={{
                                "& .MuiInputBase-input": {
                                    textTransform: "capitalize",
                                },
                            }}
                            icon={
                                <CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />
                            }
                            value={subSubCategoryId}
                            onChange={(e) => {
                                setSubSubCategoryId(e.target.value);
                            }}
                        >
                            <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>

                            {allSubSubCategories.map((val, ind) => (
                                <MenuItem
                                    key={ind}
                                    value={val?._id}
                                    sx={{ textTransform: "capitalize" }}
                                >
                                    {val?.name[currentLanguage]}
                                </MenuItem>
                            ))}
                        </CustomSelect>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack direction="row" justifyContent="flex-end">
                            <GlobalButton
                                variant="outlined"
                                handleClickBtn={handleResetFilters}
                                disabled={!hasActiveFilters || isLoading}
                                btnText="clearAllFilters"
                                startIcon={<FilterAltOffIcon sx={{ fontSize: 18 }} />}
                                styleProps={{ width: "auto", height: 36, borderRadius: 1 }}
                            />
                        </Stack>
                    </Grid>
                </Grid>

                <Box mt={2}>
                    <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                        {isLoading
                            ? Array.from({ length: 10 }).map((_, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                                    <ProductCardSkeleton />
                                </Grid>
                            ))
                            : allBasePackages.map((basePackage) => (
                                <Grid item xs={12} sm={6} md={4} lg={2.4} key={basePackage._id}>
                                    <PackageCard
                                        cardData={basePackage}
                                        selectable
                                        isSelected={selectedBasePackageIds.has(basePackage._id)}
                                        onToggleSelect={handleToggleBasePackage}
                                    />
                                </Grid>
                            ))}
                    </Grid>

                    {pagination.hasMore && !isLoading && (
                        <Box mt={3} textAlign="center">
                            <GlobalButton
                                variant="contained"
                                handleClickBtn={handleLoadMore}
                                disabled={isLoadingMore}
                                btnText={isLoadingMore ? "loading" : "loadMore"}
                                styleProps={{ width: "auto", height: 30, borderRadius: 1 }}
                            />
                        </Box>
                    )}
                </Box>
            </Box>

            <Box
                sx={{
                    flexShrink: 0,

                    borderTop: "1px solid",

                    borderColor: "divider",
                }}
            >
                <DialogActionButtons
                    onCancel={handleClose}
                    onConfirm={handleSave}
                    confirmText="attach"
                    cancelText="cancel"
                    isConfirmBtnDisable={false}
                    showCancelButton={true}
                />
            </Box>
        </StyledDrawer>
    );
});

export default AttachedBasePackageDialog;
